import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';
import type { BasicSportsWidgetConfig } from '@swf/sports/pages/types';

import { defaultState } from './defaultState';
import { effects } from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';

export interface SportsAntePostEventsWidgetModel
  extends WidgetModelConfig<BasicSportsWidgetConfig, typeof defaultState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const sportsAntePostEventsWidgetModel: SportsAntePostEventsWidgetModel = {
  state: defaultState,
  reducers,
  effects,
  selectors
};

export const useSportsAntePostEventsWidget: UseWidget<
  BasicSportsWidgetConfig,
  SportsAntePostEventsWidgetModel
> = useWidget;
